//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SetSorting from '~/components/SetSorting.vue'
import searchUtils from '~/mixins/search/search-utils'
import SearchMobileBar from '~/components/search/search-mobile-bar.vue'
import SearchFilters from '~/components/search/search-filters.vue'
import SearchResults from '~/components/search/search-results.vue'
import SearchFound from '~/components/search/search-found.vue'
import SearchChips from '~/components/search/search-chips.vue'
import { isObject } from '~/utils/v'

export default {
  name: 'SearchComponent',
  components: { SearchChips, SearchFound, SearchResults, SearchFilters, SearchMobileBar, SetSorting },
  mixins: [searchUtils],
  props: {
    title: {
      type: String,
      default: ''
    },
    withMobileBar: {
      type: Boolean,
      default: false
    },
    withFound: {
      type: Boolean,
      default: false
    },
    withSort: {
      type: Boolean,
      default: false
    },
    withPagination: {
      type: Boolean,
      default: false
    },
    withChips: {
      type: Boolean,
      default: false
    },
    withShowAllButton: {
      type: [Object],
      default: () => {
        // return {
        //   sliceCount: 3,
        //   text: this.$t('show-all'),
        //   hrefLink: null
        // }
      }
    },
    withNoResults: {
      type: Boolean,
      default: false
    },
    searchFilterFiltersFunction: {
      type: Function,
      default: i => i
    }
  },
  data () {
    return {
      mobileBar: {
        sticky: false
      },
      showAllButton: {
        text: null,
        hrefLink: null,
        sliceResults: this.withShowAllButton && this.withShowAllButton.sliceCount
          ? this.withShowAllButton.sliceCount
          : 0
      }
    }
  },
  computed: {
    show () {
      if (!this.hasSearchResult && !this.withNoResults) {
        return false
      }
      return true
    },
    resultsFilterFunction: app => (items) => {
      return app.showAllButton.sliceResults === 0
        ? items
        : items.slice(0, app.showAllButton.sliceResults)
    }
  },
  methods: {
    setSticky (isVisible, entry) {
      this.mobileBar.sticky = !isVisible
    },
    onClickShowAll () {
      if (isObject(this.withShowAllButton)) {
        if (this.showAllButton?.sliceResults) {
          this.showAllButton.sliceResults = 0
          this.showAllButton.text = this.withShowAllButton.text
          this.showAllButton.hrefLink = this.$router.resolve(this.withShowAllButton.hrefLink).href
        }
      }
    }
  }
}
